import React from 'react';
import DataTable, { TableColumn } from 'react-data-table-component';
import Marca from './Marca';




interface MarcaTableProps {
  data: Marca[];
  columns: TableColumn<Marca>[];
  customStyles: Record<string, any>;
}

const MarcaTable: React.FC<MarcaTableProps> = ({ data, columns, customStyles }) => {
  return (
    <DataTable<Marca>
      columns={columns}
      data={data}
      pagination
      paginationComponentOptions={{
        rowsPerPageText: 'Filas por página:',
        rangeSeparatorText: 'de'
      }}
      paginationPerPage={10}
      paginationRowsPerPageOptions={[10, 20, 30]}
      customStyles={customStyles}
      noDataComponent={"No hay registros para mostrar."}
    />
  );
};

export default MarcaTable;